<div style="margin-top: 10px;">
    <form [formGroup]="bankListForm">
        <mat-card class="no_box_shadow">
            <mat-card-content>
                <div class="example-button-row">
                    <span class="__filter_icon" style="background-color: white;">
                    </span>
                    <a class="__add_client" (click)="openBankForm()">
                        <mat-icon class="__icon">add_circle</mat-icon>
                        Create Bank
                    </a>
                </div>
                <mat-divider></mat-divider>
                <table mat-table matSort [dataSource]="bankListDataSource" (matSortChange)="sortData($event)">
                    <ng-container matColumnDef="code">
                        <th mat-header-cell *matHeaderCellDef class="header">
                            <div class="sorting_header">
                                <span mat-sort-header>Bank Code</span>
                                    <input placeholder="Search by Bank Code" matInput type="search"
                                        autocomplete="off" formControlName="code" class="mat-input-custom">
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">{{element.code}}</td>
                    </ng-container>
                

                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef class="header">
                            <div class="sorting_header">
                                <span mat-sort-header>Bank Name</span>
                                        <input placeholder="Search by Bank Name" matInput
                                            autocomplete="off" formControlName="name" class="mat-input-custom">
                                </div>
                        </th>
                        <td mat-cell *matCellDef="let element">{{element.name}}</td>
                    </ng-container>
                
                    <ng-container matColumnDef="branchName">
                        <th mat-header-cell *matHeaderCellDef class="header">
                            <div class="sorting_header">
                                <span mat-sort-header>Branch Name</span>
                                    <input type="search" placeholder="Search by Branch Name" matInput
                                        autocomplete="off" formControlName="branchName" class="mat-input-custom">
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">{{element.branchName}}</td>
                    </ng-container>

                    <ng-container matColumnDef="accountNo">
                        <th mat-header-cell *matHeaderCellDef class="header">
                            <div class="sorting_header">
                                <span mat-sort-header>Account No</span>
                                    <input type="search" placeholder="Search by Account No" matInput
                                        autocomplete="off" formControlName="accountNo" class="mat-input-custom">
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">{{element.accountNo}}</td>
                    </ng-container>

                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef>
                            <span class="mat-sort-header-content" style="margin-left: 50px;">Action</span></th>
                        <td class="__action_row" mat-cell *matCellDef="let element">
                            <span class="__action_edit_icon" (click)="openBankForm(element.id)">
                                <mat-icon>create</mat-icon>
                            </span>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="bankColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: bankColumns;"></tr>
                </table>

            </mat-card-content>
        </mat-card>
        <mat-paginator [pageSizeOptions]="pageSizeOptions" [length]="totalBankRecords" showFirstLastButtons></mat-paginator>
    </form>
</div>
